import React from "react";
import { Route } from "react-router-dom";
import {Layout} from "antd";
import AppHeader from "../common/AppHeader";
import {publicUrls} from "../route/Routes";

export default ({component: Component, ...rest}) => {
  return (
    <Route {...rest} render={props => (
      <Layout>
        <AppHeader homeUrl={publicUrls.basePath}/>
        <Layout.Content className="app-content">
          <div className="container">
            <Component {...rest} {...props} />
          </div>
        </Layout.Content>
      </Layout>
    )} />
  );
}